const { de: globalCommon } = require("../../common");
const { de: plasmidsCommon } = require("../../plasmids-page");

module.exports = {
	...globalCommon,
	...plasmidsCommon,
	"plasmids-sequences": require("./plasmids-sequences.json"),
	"section-try-for-free": require("../../section-try-for-free/de/section-try-for-free.json"),
};
